<template>
  <div
    v-if="priceWithinRange"
    class="klarna-container"
    :class="{ 'credit-finance': isCcfp }"
  >
    <div
      v-if="isCcfp && !isProductPerksEnabled"
      class="align-center-middle heavy-sm"
    >
      OR
    </div>
    <component
      :is="'klarna-placement'"
      class="align-center-middle"
      data-key="credit-promotion-auto-size"
      data-locale="en-US"
      :data-purchase-amount="klarnaPrice"
    />
  </div>
</template>

<script setup>
import {
  toRef, watch, onMounted, nextTick,
} from 'vue';
import useKlarna from '../composables/useKlarna';
import { useCcfp } from '../composables/useCcfp';

const props = defineProps({
  price: {
    type: Object,
    required: true,
  },
  isProductPerksEnabled: {
    type: Boolean,
    default: false,
  },
});

onMounted(() => {
  window?.Klarna?.OnsiteMessaging?.refresh();
});

const { priceWithinRange, klarnaPrice } = useKlarna(toRef(props, 'price'));
const { isCcfp } = useCcfp(toRef(props, 'price'));

watch(klarnaPrice, async () => {
  await nextTick();
  window?.Klarna?.OnsiteMessaging?.refresh();
});

</script>

<style scoped lang="scss">
.klarna-container {
  min-height: rem-calc(27);
}

.credit-finance {
  display: flex;
  gap: rem-calc(4)
}
</style>
